// extracted by mini-css-extract-plugin
export var orderSummary = "_pg-0";
export var showMoreLessButton = "_pg-1";